import { InfoIcon } from 'lucide-react'

import { assets } from '@/ui/assets'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { Tooltip, TooltipContent, TooltipContentLayout, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { links } from '@/ui/constants/links'

export function HighYieldOpportunitiesTooltip() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <InfoIcon className="icon-tertiary icon-size-xxs hover:icon-brand-primary" />
      </TooltipTrigger>
      <TooltipContent variant="long">
        <TooltipContentLayout>
          <TooltipContentLayout.Header>
            <TooltipContentLayout.Icon src={assets.lightningVioletCircle} />
            <TooltipContentLayout.Title>Higher-yield Opportunities</TooltipContentLayout.Title>
          </TooltipContentLayout.Header>
          <TooltipContentLayout.Body>
            Higher-yield Opportunities have a different risk profile compared to Savings. Make sure you understand the
            risks before depositing.{' '}
            {import.meta.env.VITE_BASE_MINI_APP !== '1' && (
              <ExternalLink to={links.docs.savings.stusds} variant="secondary">
                Learn more
              </ExternalLink>
            )}
          </TooltipContentLayout.Body>
        </TooltipContentLayout>
      </TooltipContent>
    </Tooltip>
  )
}
